<template>
    <CRow>
        <CDataTable
            class="col-12 px-0"
            :items="Object.values(shortLinks)"
            :fields="$dataTableFieldsMaker(fields)"
            hover
            :pagination="{ ...pagination, change: fetchShortLinks }"
            addTableClasses="bg-white"
        >
            <template #title="{ item }">
                <td>
                    {{ item.title }}
                </td>
            </template>

            <template #orgLink="{ item }">
                <td dir="ltr" class="text-center">
                    <CLink :href="item.url" target="_blank">
                        <FaIcon icon="link" />
                    </CLink>
                </td>
            </template>

            <template #shortedLink="{ item }">
                <td class="text-center">
                    <CLink v-clipboard:copy="item.shorted_link" v-clipboard:success="onCopy">
                        <FaIcon icon="copy" class="text-info" />
                    </CLink>
                    <CLink class="mfs-2" :href="item.shorted_link" target="_blank">
                        <FaIcon icon="link" />
                    </CLink>
                </td>
            </template>

            <template #clicks="{ item }">
                <td class="text-center">{{ item.clicks || 0 }}</td>
            </template>

            <template #createdAt="{ item }">
                <td dir="ltr">{{ $moment(item.created_at).format('jYYYY/jMM/jDD') }}</td>
            </template>

            <template #actions="{ item }">
                <td>
                    <CLink @click="editModal = { item: item, show: true }">
                        <FaIcon icon="edit" />
                    </CLink>
                </td>
            </template>
        </CDataTable>
        <CModal :show.sync="editModal.show">
            <template #header-wrapper>
                <div></div>
            </template>

            <Form :submit="submit" :shortLink="editModal.item" ref="shortLinkForm" class="px-1 pt-3" />

            <template #footer-wrapper>
                <div></div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
import Form from './Form'
import fields from './fields'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'List',

    components: {
        Form
    },

    data() {
        return {
            fields,
            editModal: {
                show: false,
                item: {},
            }
        }
    },

    computed: {
        ...mapGetters({
            shortLinks: 'shortLink/shortLinks',
            pagination: 'shortLink/pagination',
            filterMeFields: 'filterMeComponent/filterMeFields',
        }),
    },

    watch: {
        'editModal.show'() {
            this.resetMsg()
        }
    },

    methods: {
        ...mapActions({
            fetch: 'shortLink/fetch',
            edit: 'shortLink/edit',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading',
            setCToast: 'toastComponent/setCToast',
        }),
        fetchShortLinks(activePage, params = false) {
            this.fetch({
                page: activePage,
                ...params,
                ...this.filterMeFields
            })

            this.pagination.page = activePage
        },
        onCopy() {
            this.setCToast({
                msg: this.$t('short_link.link_copied'),
                class: 'text-white font-weight-bold bg-success'
            })
        },
        submit() {
            const shortLinkForm = this.$refs.shortLinkForm
            this.setShowLoading()
            this.resetMsg()

            this.edit(this.editModal.item).then(() => {
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.updateShortLink'),
                    type: 'success'
                })
                this.editModal = {item: {}, show: false}
            }).catch(result => {
                if (result.data) {
                    shortLinkForm.$refs.form.setErrors(result.data);
                }
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.' + result.tag),
                    type: 'danger'
                })
            })
        },
    },
}
</script>